import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PlaybackPlay.svg",
  "use": "PlaybackPlay.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PlaybackPlay.svg\"><path d=\"M18.8913,12.2186,54.8874,30.215a2,2,0,0,1,0,3.5771L18.8913,51.7889A2,2,0,0,1,15.9972,50V14.0071A2,2,0,0,1,18.8913,12.2186Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol